import React from "react";
import PropTypes from "prop-types";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    zIndex: 100,
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      backgroundColor: theme.palette.common.white,
      minHeight: "4rem"
    },
    [theme.breakpoints.up("sm")]: {
      position: "initial",
      bottom: "initial",
      padding: theme.spacing(1, 0, 0, 0),
    },
  },
  back: {
    marginBottom: theme.spacing(1.25),
    "&:hover": {
      textDecoration: "none",
      backgroundColor: "transparent",
    },
  },
  next: {
    position: "absolute",
    bottom: "0",
    right: "0",
    width: "auto",
    margin: theme.spacing(1.25),
    borderRadius: "5px",
    height: "2.75rem",
    fontSize: "1rem",
    "& span": {
      color: theme.palette.text.secondary,
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 0,
    }
  },
  google: {
    position: "absolute",
    height: "2.75rem",
    display: "flex",
    width: "auto",
    margin: theme.spacing(1.25),
    bottom: "0",
    left: "0",
  }
}));

const Buttons = ({
  goBack,
  showBackButton = true,
  showNextButton = true,
  showTrustpilotLogo = false,
  isDisabled = false,
  backButtonText = "Zurück",
  submitBtnText = "Weiter",
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="flex-start" alignItems="flex-start">
        {
          isDesktop &&
            showTrustpilotLogo &&
            null /* TODO: trustpilot logo here */
        }

        {showBackButton && (
          <Button
            className={classes.back}
            variant="text"
            color="secondary"
            onClick={goBack}
            disabled={isDisabled}
          >
            {backButtonText}
          </Button>
        )}

        {showNextButton && (
          <Box ml="auto">
            <Button
              className={classes.next}
              variant="contained"
              color="primary"
              type="submit"
              disabled={isDisabled}
            >
              {submitBtnText}
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
};

Buttons.propTypes = {
  goBack: PropTypes.func,
  showBackButton: PropTypes.bool,
  showTrustpilotLogo: PropTypes.bool,
  isDisabled: PropTypes.bool,
  backButtonText: PropTypes.string,
  submitBtnText: PropTypes.string.isRequired,
};

export default Buttons;
